import { Icon } from './Icon';
import { Link } from '@/components/Link';

interface NavLink {
  label: string;
  href: string;
  /** Defaults to `href`; needed when several entries share one `href`. */
  key?: string;
  onClick?: () => void;
}

interface LinkListProps {
  links: NavLink[];
}

export const LinkList = ({ links }: LinkListProps) => (
  <div className="mx-auto w-fit md:w-full">
    <div className="grid grid-cols-1 gap-x-1 gap-y-2 font-medium md:grid-cols-4">
      {links.map((link) => (
        <Link
          key={link.key ?? link.href}
          href={link.href}
          onClick={link.onClick}
          className="text-primary flex items-start gap-2 py-1 hover:underline"
        >
          <Icon
            src="/icons/svg/arrow-right.svg"
            size={20}
            className="shrink-0"
          />
          {link.label}
        </Link>
      ))}
    </div>
  </div>
);
